<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Jeff Senior was born in West Yorkshire in 1949 and continues to live there with Freda, his wife for many years. He has two sons and two grandchildren. He had a long career in IT, latterly as a freelance technical author, and then moved on to writing articles for various business magazines. Jeff is semi-retired, so he has the time to develop his writing further. This is his first published novel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?25f50918